<template>
    <div>
        <mu-avatar>头</mu-avatar>
        <label>头像</label>
    </div>
</template>
<script>
	export default{
		name:'avatar'
	}
</script>


// WEBPACK FOOTER //
// avatar.vue?266c82a2